import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';
import React from 'react';

import { DEFAULT_FONT_FAMILY, PUBSUB_GET_STORE, PUBSUB_STORE } from '../utilities';
import AppStore from './appStore';
import BotStore from './botStore';
import ChatStore from './chatStore';
import ChatWindowStore from './chatWindowStore';
import NetworkStore from './networkStore';
import UIStore from './uiStore';

export default class RootStore {
  config = {};

  constructor(config) {
    if (config.fonts && config.fonts.length) {
      const enabledFont = config.fonts.find(font => font.enabled);

      if (enabledFont) {
        config.fontFamily = enabledFont.fontFamily;
      } else {
        config.fontFamily = DEFAULT_FONT_FAMILY;
      }
    }

    this.config = Object.freeze(config);

    this.ui = new UIStore(this);
    this.chatWindow = new ChatWindowStore(this);
    this.app = new AppStore(this);
    this.bot = new BotStore(this);
    this.network = new NetworkStore(this);
    this.chat = new ChatStore(this);
  }
}

const StoreContext = React.createContext(null);

export function StoreProvider({ children, config }) {
  const [store] = React.useState(() => new RootStore(config));

  React.useEffect(() => {
    PubSub.subscribe(PUBSUB_GET_STORE, () => {
      PubSub.publish(PUBSUB_STORE, store);
    });

    return () => {
      PubSub.unsubscribe(PUBSUB_GET_STORE);
    };
  }, [store]);

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}

StoreProvider.propTypes = {
  config: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired
};

export function useStores() {
  return React.useContext(StoreContext);
}
